import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

const AccessSecurity = ({ selected }) => {
  return (
    <li
      className={`user-item item-calendar px-1 py-0 py-1 border-bottom border-color-ui-3 ${
        selected === '/security-access' ? 'active' : ''
      }`}
      role='menuitem'
    >
      <div className='row align-items-center h-100 mx-0'>
        <Link
          className='profile-button txt-menu-listy col mr-auto btn btn-flat btn-sm btn-icon txt-left txt-font-body txt-uppercase'
          to='/security-access'
          tabIndex='1'
        >
          <i className='icon icon_lock' />
            Acessos e segurança
        </Link>
      </div>
    </li>
  )
}

AccessSecurity.propTypes = {
  selected: PropTypes.string
}

export default AccessSecurity



// WEBPACK FOOTER //
// ./src/App/Shell/AccessSecurity.js